import { render } from "./ChatBody.vue?vue&type=template&id=605f66c2&scoped=true"
import script from "./ChatBody.vue?vue&type=script&lang=js"
export * from "./ChatBody.vue?vue&type=script&lang=js"

import "./ChatBody.vue?vue&type=style&index=0&id=605f66c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605f66c2"]])

export default __exports__